<template>
  <div class="tem_info">
    <el-row>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="hyss">今日活跃用户</div>
          <div class="hyss_num">{{dataFrom.userCount || 0}}<span>人</span></div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="hyss">操作系统</div>
          <div class="hyss_num">{{dataFrom.osName}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="hyss">CPU核心数</div>
          <div class="hyss_num">{{dataFrom.cpuNum}}<span>核</span></div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="hyss">本次运行时间</div>
          <div class="hyss_num">{{dataFrom.runTime}}</div>
        </div>
      </el-col>
    </el-row>
    <div class="echEcharts2">
      <div class="title">CPU的使用率</div>
      <div style="height:300px">
        <Echarts2 :data="echartsData" />
      </div>
    </div>
    <div class="echEcharts2" style="background:none;padding:0">
      <el-row>
        <el-col :span="12" style="padding-left:0;">
          <div class="grid-content bg-purple">
            <div class="title">内存使用率</div>
            <div style="height:300px">
              <Echarts1 :data="echartsData1" :total="dataFrom.totalMemory"/>
            </div>
          </div>
        </el-col>
        <el-col :span="12" style="padding-right:0;">
          <div class="grid-content bg-purple">
           <div class="title">硬盘使用率</div>
            <div style="height:300px">
              <Echarts1 :data="echartsData3"  :total="dataFrom.totalFile"/>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Echarts2 from './compontents/Echarts2'
import Echarts1 from './compontents/Echarts1'
import {getAgentCount} from '@/api/home.js'
export default {
  components:{
    Echarts2,
    Echarts1
  },
  data(){
    return{
      dataFrom:{},
      echartsData:{
        sData:[],
        xData:[]
      },
      echartsData1:[],
      echartsData3:[]
    }
  },
  created(){
    
  },
  mounted() {
    this.getSearch()
  },
  methods:{
    getSearch(){
      getAgentCount().then(res=>{
        this.dataFrom = res.data.data
        res.data.data.cpuList.forEach(item=>{
          this.echartsData.sData.push(item.cpuUse)
          this.echartsData.xData.push(item.createTime)
        })
        this.echartsData1=[
          {value:res.data.data.useMemory,name:'已使用内存'},
          {value:res.data.data.freeMemory,name:'剩余内存'}
        ]
        this.echartsData3=[
          {value:res.data.data.useFile,name:'已使用'},
          {value:res.data.data.freeFile,name:'剩余'}
        ]
        console.log(res)
      })
    },
  }
}
</script>
<style lang="less" scoped>
.tem_info{
  height:100%;
  background:#F3F5F9;
  padding:10px 26px;
  .el-row{
    .el-col-6{
      padding:10px;
      .grid-content{
        background:#fff;
        height:96px;
        text-align: center;
        .hyss{
          color:#636C88;
          font-size:14px;
          padding-top:20px;
          padding-bottom:10px;
        }
        .hyss_num{
          color:#19213F;
          font-size:20px;
          padding-right: 4px;
          span{
            color:#636C88;
            font-size:12px;
            display: inline-block;
          }
        }
      }
    }
  }
  .echEcharts2{
    margin-top:20px;
    padding:20px;
    background:#fff;
    border-radius: 8px;
    .title{
      color: #19213F;
      font-size:18px;
      font-weight:bold;
    }
    .el-row{
      .el-col-12{
         padding:0 10px;
        .grid-content{
          .title{
            padding:20px;
          }
           border-radius: 8px;
          background:#fff;
        }
      }
    }
  }
}
</style>